import { ComponentProps } from 'react';

import { UserAvatar as UserAvatarLib } from '@pletly/ui';
import { useAuthHeaders } from '%hooks/auth';

export const UserAvatar = ({ src, ...avatarProps }: Props) => {
	const { getHeaders } = useAuthHeaders();
	const source = src ? { uri: src, headers: getHeaders(src) } : undefined;

	return <UserAvatarLib source={source} {...avatarProps} />;
};

type Props = ComponentProps<typeof UserAvatarLib> & {
	src?: string | null;
};
